function ebTemplateToggleTOC() {
  const tocList = document.querySelector('.eb-template-toc-list');
  tocList.style.display = tocList.style.display === 'none' ? 'block' : 'none';
}
  document.addEventListener("DOMContentLoaded", function () {
    const tocToggleBtn = document.querySelector('.eb-template-toc-toggle');

    if (tocToggleBtn && !tocToggleBtn.getAttribute('onclick')) {
      tocToggleBtn.setAttribute('onclick', 'ebTemplateToggleTOC()');
    }
  });

/* mossriver-funnel-instrument-v1: article -> PDP attribution */
(function () {
  "use strict";
  function trackArticlePathClick(event) {
    const link = event.target.closest("#mossriver-exp-20260808-article-pdp a");
    if (!link || !window.dataLayer) return;
    const url = new URL(link.href, window.location.origin);
    const campaign = url.searchParams.get("utm_campaign");
    if (!campaign) return;
    const payload = {
      event: "mossriver_article_pdp_click",
      mossriver_funnel_id: "mossriver-exp-20260808-article-pdp",
      destination_path: url.pathname,
      link_text: (link.textContent || "").trim(),
      campaign: campaign,
      content: url.searchParams.get("utm_content") || ""
    };
    window.dataLayer.push(payload);
    if (typeof window.gtag === "function") {
      window.gtag("event", "article_pdp_click", {
        funnel_id: payload.mossriver_funnel_id,
        destination_path: payload.destination_path,
        campaign: payload.campaign,
        content: payload.content
      });
    }
  }
  document.addEventListener("click", trackArticlePathClick, false);
}());
